if (!customElements.get('sticky-bar')) {
  customElements.define('sticky-bar', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.watchElement = [...document.querySelectorAll(`.${this.dataset.target}`)].find(element => !element.closest('sticky-bar'));

      if(!this.watchElement) return;

      this.createObserve();
    }

    createObserve(){
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const intersecting = entry.isIntersecting
          this.classList.toggle('visible', !intersecting)
        })
      })

      observer.observe(this.watchElement)
    }
  });
}
